"use strict";
module.exports = {
    entityModel: 'end-customer-in-inventory',
    events: {
        END_CUSTOMER_IN_INVENTORY_CREATED: 'END_CUSTOMER_IN_INVENTORY_CREATED',
        END_CUSTOMER_IN_INVENTORY_UPDATED: 'END_CUSTOMER_IN_INVENTORY_UPDATED',
    },
    actions: {
        get: 'v1.end-customer-in-inventory.get',
        list: 'v1.end-customer-in-inventory.list',
        upsert: 'v1.end-customer-in-inventory.upsert',
        upsertWhenEmpty: 'v1.end-customer-in-inventory.upsertWhenEmpty',
        updateWhenEmpty: 'v1.end-customer-in-inventory.updateWhenEmpty',
        update: 'v1.end-customer-in-inventory.update',
    },
};
